import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-epad-tranings',
  templateUrl: './epad-tranings.component.html',
  styleUrls: ['./epad-tranings.component.scss']
})
export class EpadTraningsComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
